/**
 * Projectcards: het beeld staat stil, bij hover speelt de video.
 *
 * Twee varianten, hetzelfde gedrag. Ligt er een uitgelichte afbeelding onder,
 * dan fade de video daaroverheen en krijgt hij pas bij de eerste hover een src,
 * anders begint een archiefpagina met een dozijn videodownloads. Is er geen
 * afbeelding, dan staat de video zelf stil in beeld en hoeft er niets te faden.
 *
 * Op touch (geen hover) en bij prefers-reduced-motion gebeurt er niets: het
 * stilstaande beeld blijft staan.
 */
export default function initProjectCards() {
  const cards = document.querySelectorAll('[data-project-card]');

  if (!cards.length) {
    return;
  }

  if (!window.matchMedia('(hover: hover)').matches) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  cards.forEach((card) => {
    const video = card.querySelector('video');
    const trigger = card.closest('.group') || card;

    if (!video) {
      return;
    }

    // Alleen de variant met een afbeelding eronder begint onzichtbaar en fade.
    const fades = video.classList.contains('opacity-0');
    let hovering = false;

    // Pas faden zodra er echt beeld is, anders zie je even een zwart vlak.
    if (fades) {
      video.addEventListener('playing', function () {
        if (hovering) {
          video.classList.remove('opacity-0');
        }
      });
    }

    trigger.addEventListener('mouseenter', function () {
      hovering = true;

      if (video.dataset.src && !video.getAttribute('src')) {
        video.setAttribute('src', video.dataset.src);
      }

      const played = video.play();

      if (played && typeof played.catch === 'function') {
        played.catch(function () {});
      }
    });

    trigger.addEventListener('mouseleave', function () {
      hovering = false;

      if (fades) {
        video.classList.add('opacity-0');
      }

      video.pause();
      video.currentTime = 0;
    });
  });
}
